import {Component, OnInit, ViewChild} from '@angular/core';
import {ExcTranslation} from 'exc-core';
import {ExcListComponent, ExcListConfig, ExcSectionGroupComponent, OverlayConfig, OverlayRef} from 'exc-controls';
import {DefaultSettingsService} from '../../default-settings-service.service';
import {ExcRestService} from 'exc-rest';

@Component({
  selector: 'app-modal-review-group-edit',
  templateUrl: './modal-review-group-edit.component.html',
  styles: []
})
export class ModalReviewGroupEditComponent extends ExcTranslation implements OnInit {

  candidates: any[] = [];
  allAudits: any[] = [];
  listConfigStep1candidates: ExcListConfig = new ExcListConfig();
  listConfigStep1allAudits: ExcListConfig = new ExcListConfig();

  listconfig2: ExcListConfig = new ExcListConfig();
  searchValue: string = null;
  selectedItemsCandidates: any[] = [];
  selectedItemsallAudits: any[] = [];
  selectedItems: any[] = [];
  step = 1;
  headerAudit: number = null;
  selectionForHeader: any[] = [];
  groupID: string = null;
  candidateMode = true;
  step1InitialallAudits = true;
  step1Initialcandidates = true;
  @ViewChild('listStep1Candidates') listStep1Candidates: ExcListComponent;
  @ViewChild('listStep1allAudits') listStep1allAudits: ExcListComponent;
  @ViewChild('tabContainer') tabContainer: ExcSectionGroupComponent;

  constructor(private overlayRef: OverlayRef, private overlayConfig: OverlayConfig, private excDss: DefaultSettingsService, private excRest: ExcRestService) {
    super();
    const _self = this;
    _self.listConfigStep1candidates.OnRefresh = (event?) => { _self.loadData(); };
    _self.listConfigStep1candidates.selectionMode =  'multi';
    _self.listConfigStep1candidates.paging = {pagingTotalRows: 0, pagingTotalPages: 0, pagingPage: 0, pagingPageSize: 10};
    _self.listConfigStep1candidates.OnSearch = function (searchValue) {
      _self.searchValue = searchValue || '';
      _self.loadCandidates();
    };
    _self.listConfigStep1candidates.OnPageChanged = (pageNo) => {
      _self.listConfigStep1candidates.paging.pagingPage = pageNo;
      _self.loadCandidates();
    };
    _self.listConfigStep1candidates.OnRefresh = () => {
      _self.loadCandidates();
    };
    _self.listConfigStep1candidates.OnSelectionChanged = (selectedItems: any) => {
      _self.selectedItemsCandidates = [...selectedItems];
    };
    _self.listConfigStep1allAudits.OnRefresh = (event?) => { _self.loadData(); };
    _self.listConfigStep1allAudits.selectionMode =  'multi';
    _self.listConfigStep1allAudits.paging = {pagingTotalRows: 0, pagingTotalPages: 0, pagingPage: 0, pagingPageSize: 10};
    _self.listConfigStep1allAudits.OnSearch = function (searchValue) {
      _self.searchValue = searchValue || '';
      _self.loadAllAudits();
    };
    _self.listConfigStep1allAudits.OnPageChanged = (pageNo) => {
      _self.listConfigStep1allAudits.paging.pagingPage = pageNo;
      _self.loadAllAudits();
    };
    _self.listConfigStep1allAudits.OnRefresh = () => {
      _self.loadAllAudits();
    };
    _self.listConfigStep1allAudits.OnSelectionChanged = (selectedItems: any) => {
      _self.selectedItemsallAudits = [...selectedItems];
    };
    _self.listconfig2.selectionMode = 'single';
    _self.listconfig2.OnFocus = (focusItem, event?) => {
        _self.headerAudit = focusItem;
    };
  }

  ngOnInit() {
    this.groupID = this.overlayConfig.data.Audits[0]['AuditGroup'];
    this.loadCandidates();
    this.loadAllAudits();
  }
  loadData() {
    if (this.candidateMode === true) {
      this.loadCandidates();
    } else {
      this.loadAllAudits();
    }
  }

  loadAllAudits() {
    const _self = this;
    let grp = null;
    if (this.overlayConfig.data.Audits !== null && this.overlayConfig.data.Audits.length > 0) {
      grp = this.overlayConfig.data.Audits[0]['AuditGroup'];
    }
    const mi = _self.listConfigStep1allAudits.GetMetaInfo();
    const url = _self.excRest.computeUrl('ReviewGroupR_ListAllPossible', {AuditGroup: grp, fts: (_self.searchValue !== '' ? _self.searchValue : null)});
    _self.listConfigStep1allAudits.isLoading = true;
    _self.excRest.get(url, {MetaInfo: mi}).subscribe(cd => {
      _self.allAudits = cd.data;
      _self.listConfigStep1allAudits.paging = cd.paging;
      _self.listConfigStep1allAudits.isLoading = false;
      if (this.step1InitialallAudits === true) {
        for (let a = 0; a < _self.allAudits.length; a++) {
          for (let b = 0; b < _self.overlayConfig.data.Audits.length; b++) {
            if (_self.allAudits[a]['AuditID'] === _self.overlayConfig.data.Audits[b]['AuditID']) {
              _self.listStep1allAudits.toggleSelect(_self.allAudits[a]);
            }
          }
        }
        _self.step1InitialallAudits = false;
      }
    });
  }
  loadCandidates() {
    const _self = this;
    let grp = null;
    if (this.overlayConfig.data.Audits !== null && this.overlayConfig.data.Audits.length > 0) {
      grp = this.overlayConfig.data.Audits[0]['AuditGroup'];
    }
    const mi = _self.listConfigStep1candidates.GetMetaInfo();
    const url = _self.excRest.computeUrl('ReviewGroupR_ListCandidates', {AuditGroup: grp, AuditID: _self.overlayConfig.data.Audits[0]['AuditID'], fts: _self.searchValue !== '' ? _self.searchValue : null});
    _self.listConfigStep1candidates.isLoading = true;
    _self.excRest.get(url, {MetaInfo: mi}).subscribe(cd => {
      _self.candidates = cd.data;
      _self.listConfigStep1candidates.paging = cd.paging;
      _self.listConfigStep1candidates.isLoading = false;
      if (this.step1Initialcandidates === true) {
        for (let a = 0; a < _self.candidates.length; a++) {
          for (let b = 0; b < _self.overlayConfig.data.Audits.length; b++) {
            if (_self.candidates[a]['AuditID'] === _self.overlayConfig.data.Audits[b]['AuditID']) {
              _self.listStep1Candidates.toggleSelect(_self.candidates[a]);
            }
          }
        }
        _self.step1Initialcandidates = false;
      }
    });
  }
  getAvatarClass(data) {
    return data.AuditType === 16
      ? data.AuditIsPicked ? 'fa-mobile th-warning' : 'fa-mobile th-secondary'
      : data.AuditIsPicked ? 'fa-user-secret th-warning' : 'fa-user-secret th-secondary';
  }
  nextStep() {
    const _self = this;
    if (_self.step === 1) {
      _self.selectionForHeader = [];
      if (_self.tabContainer.currentTabIndex === 1) {
        for (const x of _self.selectedItemsCandidates) {
          _self.selectionForHeader.push(x);
        }
      } else {
        for (const x of _self.selectedItemsallAudits) {
          _self.selectionForHeader.push(x);
        }
      }
      // _self.selectionForHeader.push(_self.overlayConfig.data.Audit);
      _self.step = 2;
    } else {
      let audits = '';
      for (let i = 0; i < _self.selectionForHeader.length; i++) {
        audits =  audits + _self.selectionForHeader[i]['AuditID'] + '|';
      }
      audits = audits + _self.overlayConfig.data.Audit['AuditID'];
      _self.overlayRef.close({proceed: true, AuditIDs: audits, AuditLead: _self.headerAudit['AuditID']});
    }
  }
  backStep() {
    const _self = this;
    if (_self.step === 1) {
      _self.overlayRef.close({proceed: false});
    } else {
      _self.step = _self.step - 1;
    }
  }
}
